import {
    JIT_SUPPORTED_PROTOCOLS,
    PRIVILEGED_DEFAULT_SERVICES
} from '@silverfort-nodelibs/common/utils/consts';
import { Drawer } from '@silverfort/sf-components';
import NamingConventions from './NamingConventions';
import { useEffect, useState } from 'react';
import OutScopeBadge from '../Badge/OutScopeBadge';
import InScopeBadge from '../Badge/InScopeBadge';
import { TIER_SCOPES, DEFAULT_PROTOCOLS_AD } from '../TierConsts';

const normalizeConvention = (convention) => {
    const protocols = convention.protocols ?? DEFAULT_PROTOCOLS_AD;
    const hasKerberos = protocols.includes(JIT_SUPPORTED_PROTOCOLS.KERBEROS);
    const services = convention.services ?? (hasKerberos ? [...PRIVILEGED_DEFAULT_SERVICES] : []);
    return { ...convention, protocols, services };
};

const NameConventionDrawer = ({ open, scope, conventions, onClose, onSaveConventions, defaultSelectedConvention }) => {
    const [shouldDisableSave, setShouldDisableSave] = useState(true);
    const [tempConventions, setTempConventions] = useState(conventions.map(normalizeConvention));
    const [selectedConvention, setSelectedConvention] = useState(defaultSelectedConvention || 0);

    useEffect(() => {
        setSelectedConvention(defaultSelectedConvention);
    }, [defaultSelectedConvention]);

    useEffect(() => {
        if (!open) {
            setTempConventions(conventions.map(normalizeConvention));
            setSelectedConvention(defaultSelectedConvention || 0);
        }
    }, [open, conventions, defaultSelectedConvention]);

    const saveConventions = () => {
        const validConventions = tempConventions.filter((convention) => convention.conditionString);
        onClose();
        onSaveConventions(validConventions);
    };

    return (
        <Drawer
            footerActionTitle="Save"
            footerCloseTitle="Cancel"
            footerActionProps={{
                disabled: shouldDisableSave
            }}
            onAction={saveConventions}
            variant="persistent"
            open={open}
            onClose={onClose}
            anchor="right"
            headerTitle={
                <div className="flex gap-2">
                    <div>Naming conventions</div>
                    {scope === TIER_SCOPES.IN_SCOPE ? <InScopeBadge /> : <OutScopeBadge />}
                </div>
            }
            className="w-[680px] max-w-[680px]">
            <NamingConventions
                setShouldDisableSave={setShouldDisableSave}
                scope={scope}
                conventions={tempConventions}
                setConventions={setTempConventions}
                selectedConvention={selectedConvention}
                setSelectedConvention={setSelectedConvention}
            />
        </Drawer>
    );
};

export default NameConventionDrawer;
